import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, switchMap } from 'rxjs/operators';
import * as WebSocketActions from '../actions/websockets.actions';
import { WebsocketService } from '../../service/websocket.service';

@Injectable()
export class WebSocketEffects {
    constructor(
        private actions$: Actions,
        private websocketService: WebsocketService
    ) {}

    connectWebSocket$ = createEffect(() => this.actions$.pipe(
        ofType(WebSocketActions.connectWebSocket),
        map((action) => {
            this.websocketService.connect(action.personaId);
        })
    ), { dispatch: false });

    disconnectWebSocket$ = createEffect(() => this.actions$.pipe(
        ofType(WebSocketActions.disconnectWebSocket),
        map(() => {
            this.websocketService.disconnect();
        })
    ), { dispatch: false });
}
